// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607020512/js/" + chunkId + "." + {"44":"4a4f1c1b","225":"ecc11015","481":"576da546","486":"fef48199","770":"c600d172"}[chunkId] + ".0.6025813464986168.chunk.js";
};